<template>
  <table>
    <tbody>
      <tr>
        <translate tag="td"> Was </translate>
        <td class="was">
          <pu-price :price="preDiscountPrice" />
        </td>
      </tr>
      <tr v-for="(offer, index) in offersApplied" :key="index">
        <!-- TODO: needs translation -->
        <td colspan="2" class="offer-color right">
          *{{ offer.name }} ({{ offer.discountPercent }}% off)
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { OfferApplied } from '../../../types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { SimpleMoney } from '~/utility/money'

@Component
class OffersActive extends Vue {
  @Prop()
  preDiscountPrice: SimpleMoney

  @Prop()
  offersApplied: OfferApplied[]
}

export default toNative(OffersActive)
</script>
